import { X, RotateCcw, Trash2 } from '../../icons';
import { tWorkspace } from '../../lib/workspace-i18n';

/**
 * 휴지통 선택 툴바 (2026-08-14) — 사용자 요구: "휴지통도 내 파일처럼 체크해서 삭제기능".
 *
 * 목록의 선택 툴바(`WorkspaceSelectionBar`)와 **같은 자리·같은 모양**이지만 동작은 둘뿐이다.
 * 휴지통에서 공유·이동·이름바꾸기는 뜻이 없고, 여기서의 '삭제' 는 **영구 삭제**라 같은
 * 컴포넌트에 섞으면 위험하다 — 버튼 위치가 같은데 결과가 다른 것이 제일 나쁘다.
 */
export function WorkspaceTrashBar({
  count, onClear, onRestore, onPurge,
}: {
  count: number;
  onClear: () => void;
  onRestore: () => void;
  onPurge: () => void;
}) {
  return (
    <div className="ws-selbar" role="toolbar" aria-label={tWorkspace('workspace.sel.aria')}>
      <button
        type="button"
        className="ws-selbar-clear"
        onClick={onClear}
        aria-label={tWorkspace('workspace.sel.clear')}
      >
        <X size={15} aria-hidden />
      </button>
      <span className="ws-selbar-count ws-num">
        {tWorkspace('workspace.sel.count', { count })}
      </span>

      <button type="button" className="ws-selbar-btn" onClick={onRestore}>
        <RotateCcw size={14} aria-hidden /> {tWorkspace('workspace.trash.restore')}
      </button>
      <button type="button" className="ws-selbar-btn ws-selbar-btn--danger" onClick={onPurge}>
        <Trash2 size={14} aria-hidden /> {tWorkspace('workspace.trash.purge')}
      </button>
    </div>
  );
}
